module.exports = __webpack_public_path__ + "static/img/partner12.04646a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner12.png
// module id = Ysq9
// module chunks = 0